export function capitalize(string){  
  try {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } catch(error){
    return string;
  }  
}

export function initials(string1, string2){  
  let resp = '';
  try {
    resp = string1.charAt(0);
  } catch(error){}  

  try {
    resp += string2.charAt(0);
  } catch(error){}  
  return resp;
}